import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FormattedWeight } from '../../../components/formatted-weight';
import style from '../../../components/orders-grid/columns/weight.module.less';
import messages from '../messages';

const name = <FormattedMessage {...messages.weightColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.weightColumnHeader,
  name,
  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return null;
    }
    if (data.weight === 0) {
      return null;
    }
    const weight = {
      value: data.weight,
      unit: data.weightUnitOfMeasureId,
    };
    return (
      <div className={style['weight-column']}>
        <FormattedWeight weight={weight} />
      </div>
    );
  },
};
